import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route } from 'react-router-dom'
import "./index.css"
import Navbar from './Components/Navbar'
import Home from "./Components/Home"
import Services from "./Components/Services"
import Gallery from "./Components/Gallery"
import Footer from './Components/Footer';
import Contact from "./Components/Contact"
import Aboutus from './Components/Aboutus';
import Gallery2 from './Components/Gallery2';
import Header from './Components/Header';
import ReactWhatsapp from 'react-whatsapp';

function App() {
  return (
    <>
      <Header />

      <Navbar />
      <Route exact path="/" >
        <Home />
      </Route>

      <Route exact path="/Aboutus" >
        <Aboutus />
      </Route>

      <Route exact path="/Services" >
        <Services />
      </Route>

      <Route exact path="/Gallery2" >
        <Gallery2 />
      </Route>

      <Route exact path="/Contact" >
        <Contact />
      </Route>

      <Footer />
      <ReactWhatsapp number="+92-314-2086253" message="Hello World!!!" />
      

    </>
  )
}

export default App
